<template>
  <div
    class="list_item__container"
  >
    <div class="list_item__content list_item__element"
         :class="{ is_last: isLast }">
      <div class="list_item__title">
        <slot name="left"></slot>
      </div>
    </div>
    <div class="list_item__action list_item__element">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ListItemWithSlots extends Vue {
  @Prop({ default: false })
  isLast!: boolean
}
</script>

<style scoped>
.list_item__container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 44px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: #e8e8e8 solid 1px;
  border-collapse: collapse;
  background-color: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
}

.list_item__container.list_item__container_warning {
  color: #ff003d;
  border: 1px #ff003d solid;
}

.list_item__element {
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 12px;
}

.list_item__content {
  align-self: start;
  padding-top: 0px;
  padding-left: 16px;
}
.list_item__action {
  text-align: right;
  padding-right: 16px;
}

.is_last {
  border-bottom: none;
}
</style>
